export default {
    games: [
        {
            description: 'Blossom Blast Saga',
            id: 'blossomblast'
        },
        {
            description: 'Bubble Witch 2 Saga',
            id: 'bubblewitch2'
        },
        {
            description: 'Bubble Witch 3 Saga',
            id: 'bubblewitch3'
        },
        {
            description: 'Candy Crush Saga',
            id: 'candycrush'
        },
        {
            description: 'Candy Crush Friends Saga',
            id: 'myling'
        },
        {
            description: 'Candy Crush Jelly Saga',
            id: 'candycrushjelly'
        },
        {
            description: 'Candy Crush Soda Saga',
            id: 'candycrushsoda'
        },
        {
            description: 'Candy Crush Solitaire',
            id: 'candysolitaire'
        },
        {
            description: 'Diamond Diaries Saga',
            id: 'gravity'
        },
        {
            description: 'Farm Heroes Saga',
            id: 'farmking'
        },
        {
            description: 'Farm Heroes Super Saga',
            id: 'farmheroessuper'
        },
        {
            description: 'Minecraft Blast',
            id: 'diamonds'
        },
        {
            description: 'Pet Rescue Saga',
            id: 'petrescue'
        },
        {
            description: 'Pyramid Solitaire Saga',
            id: 'pyramid'
        }
    ],
    issueTypes: [
        {
            i18nKey: 'field.topic.option.problems_with_purchases',
            description: 'Purchase issues/questions',
            id: 'purchase'
        },
        {
            i18nKey: 'field.topic.option.problems_or_security_issues_with_my_game',
            description: 'Bugs/technical/security issues ',
            id: 'gameplay_progress'
        },
        {
            i18nKey: 'field.topic.option.general_questions',
            description: 'Questions about my game',
            id: 'general_questions'
        },
        {
            i18nKey: 'field.topic.option.privacy',
            description: 'Privacy and legal',
            id: 'privacy'
        },
        {
            i18nKey: 'field.topic.option.report_ads',
            description: 'Advert issues/reporting',
            id: 'report_ads'
        },
        {
            i18nKey: 'field.topic.option.lost_progress_items',
            description: 'Lost progress/items',
            id: 'lost_progress_items'
        },
        {
            i18nKey: 'field.topic.option.event_issues',
            description: 'Event and features issues',
            id: 'event_issues'
        },
        {
            i18nKey: 'field.topic.option.feedback',
            description: 'Feedback',
            id: 'feedback'
        },
        {
            i18nKey: 'field.topic.option.account_queries_issues',
            description: 'Account login questions/issues',
            id: 'account_queries_issues'
        },
        {
            i18nKey: 'field.topic.option.community_report_abuse',
            description: 'Abuse, cheating, or appeal moderation/decision',
            id: 'community_report_abuse'
        }
    ],
    issueSubTypes: {
        purchase: [
            {
                i18nKey: 'field.subtopic.option.unsuccessful_purchase',
                description: "I'm unable to make a purchase",
                id: 'unsuccessful_purchase'
            },
            {
                i18nKey: 'field.subtopic.option.accidental_purchase',
                description: 'I made an accidental purchase',
                id: 'accidental_purchase'
            },
            {
                i18nKey: 'field.subtopic.option.purchase_not_received',
                description: "I didn't receive my purchase",
                id: 'purchase_not_received'
            },
            {
                i18nKey: 'field.subtopic.option.payment_queries',
                description: 'I have a question regarding purchases',
                id: 'payment_queries'
            },
            {
                i18nKey: 'field.subtopic.option.overcharged_purchase',
                description: 'I was overcharged for a purchase',
                id: 'overcharged_purchase'
            },
            {
                i18nKey: 'field.subtopic.option.gifting_card',
                description: 'I have a query or issue regarding my gift card',
                id: 'gifting_card'
            }
        ],
        gameplay_progress: [
            {
                i18nKey: 'field.subtopic.option.game_crash',
                description: 'My game is crashing',
                id: 'game_crash'
            },
            {
                i18nKey: 'field.subtopic.option.live_tickets_issue',
                description: "I can't send/receive lives",
                id: 'live_tickets_issue'
            },
            {
                i18nKey: 'field.subtopic.option.level_bug',
                description: 'I have a bug with a level',
                id: 'level_bug'
            },
            {
                i18nKey: 'field.subtopic.option.game_freeze',
                description: 'My game is freezing',
                id: 'game_freeze'
            },
            {
                i18nKey: 'field.subtopic.option.connection_issues',
                description: 'I have connection issues',
                id: 'connection_issues'
            }
        ],
        general_questions: [
            {
                i18nKey: 'field.subtopic.option.gameplay_questions',
                description: 'I have a question about my game',
                id: 'gameplay_questions'
            },
            {
                i18nKey: 'field.subtopic.option.not_pass_level',
                description: 'How do I pass this level?',
                id: 'not_pass_level'
            },
            {
                i18nKey: 'field.subtopic.option.new_levels',
                description: 'When are new levels released?',
                id: 'new_levels'
            }
        ],
        privacy: [
            {
                i18nKey: 'field.subtopic.option.permanently_delete_my_account',
                description: 'I want to permanently delete my account',
                id: 'permanently_delete_my_account'
            },
            {
                i18nKey: 'field.subtopic.option.provide_my_information',
                description: 'Please provide my information',
                id: 'provide_my_information'
            },
            {
                i18nKey: 'field.subtopic.option.direct_marketing_opt_out',
                description: 'I want to opt out from direct marketing',
                id: 'direct_marketing_opt_out'
            },
            {
                i18nKey: 'field.subtopic.option.personalised_ads_opt_out_do_not_sell_my_data',
                description: 'Do not sell or share my information/personalised adverts opt-out',
                id: 'personalised_ads_opt_out_do_not_sell_my_data'
            },
            {
                i18nKey: 'field.subtopic.option.right_to_appeal',
                description: 'Right to appeal',
                id: 'right_to_appeal'
            },
            {
                i18nKey: 'field.subtopic.option.right_to_correction',
                description: 'Right to correction',
                id: 'right_to_correction'
            },
            {
                i18nKey: 'field.subtopic.option.other_legal_queries',
                description: 'I have another legal query',
                id: 'other_legal_queries'
            },
            {
                i18nKey: 'field.subtopic.option.date_of_birth',
                description: 'Date of birth',
                id: 'date_of_birth'
            }
        ],
        report_ads: [
            {
                i18nKey: 'field.subtopic.option.fraudulent_ads',
                description: 'I want to report an advert',
                id: 'fraudulent_ads'
            },
            {
                i18nKey: 'field.subtopic.option.ad_bug',
                description: 'I experienced a bug with an advert',
                id: 'ad_bug'
            },
            {
                i18nKey: 'field.subtopic.option.ad_reward_not_received',
                description: "I didn't receive my reward for watching an advert",
                id: 'ad_reward_not_received'
            },
            {
                i18nKey: 'field.subtopic.option.missing_adverts',
                description: "I'm no longer seeing adverts in my game",
                id: 'missing_adverts'
            }
        ],
        lost_progress_items: [
            {
                i18nKey: 'field.subtopic.option.progress_lost',
                description: 'I lost my progress',
                id: 'progress_lost'
            },
            {
                i18nKey: 'field.subtopic.option.lost_items',
                description: 'I have lost items',
                id: 'lost_items'
            },
            {
                i18nKey: 'field.subtopic.option.streak_lost',
                description: 'I have lost my win or daily streak',
                id: 'streak_lost'
            }
        ],
        event_issues: [
            {
                i18nKey: 'field.subtopic.option.reward_not_received',
                description: "I didn't receive my reward",
                id: 'reward_not_received'
            },
            {
                i18nKey: 'field.subtopic.option.missing_events',
                description: "I'm missing events or features in my game",
                id: 'missing_events'
            },
            {
                i18nKey: 'field.subtopic.option.event_bug',
                description: 'I have a bug with an event or feature',
                id: 'event_bug'
            }
        ],
        feedback: [
            {
                i18nKey: 'field.subtopic.option.accessibility',
                description: 'I have accessibility feedback',
                id: 'accessibility'
            },
            {
                i18nKey: 'field.subtopic.option.event_feedback',
                description: 'I have feedback on an event or game feature',
                id: 'event_feedback'
            },
            {
                i18nKey: 'field.subtopic.option.feedback_other',
                description: 'I have other feedback',
                id: 'feedback_other'
            }
        ],
        account_queries_issues: [
            {
                i18nKey: 'field.subtopic.option.play_on_another_device',
                description: 'I want to transfer my progress to another device',
                id: 'play_on_another_device'
            },
            {
                i18nKey: 'field.subtopic.option.not_connect_facebook',
                description: 'I have account login issues',
                id: 'not_connect_facebook'
            },
            {
                i18nKey: 'field.subtopic.option.password_reset',
                description: 'I have issues resetting my password',
                id: 'password_reset'
            },
            {
                i18nKey: 'field.subtopic.option.account_query',
                description: 'I have a question about my account',
                id: 'account_query'
            }
        ],
        community_report_abuse: [
            {
                i18nKey: 'field.subtopic.option.bullying',
                description: 'Bullying or harassment',
                id: 'bullying'
            },
            {
                i18nKey: 'field.subtopic.option.graphic_violence',
                description: 'Graphic violence and human gore',
                id: 'graphic_violence'
            },
            {
                i18nKey: 'field.subtopic.option.exposure_private_sexual_images',
                description: 'Threat or exposure of private sexual images',
                id: 'exposure_private_sexual_images'
            },
            {
                i18nKey: 'field.subtopic.option.child_sexual_abuse',
                description: 'Child sexual abuse',
                id: 'child_sexual_abuse'
            },
            {
                i18nKey: 'field.subtopic.option.hate_speech',
                description: 'Hate speech',
                id: 'hate_speech'
            },
            {
                i18nKey: 'field.subtopic.option.suicide',
                description: 'Suicide or self-harm',
                id: 'suicide'
            },
            {
                i18nKey: 'field.subtopic.option.sexually_inappropriate_conduct',
                description: 'Sexually inappropriate conduct',
                id: 'sexually_inappropriate_conduct'
            },
            {
                i18nKey: 'field.subtopic.option.terrorism',
                description: 'Terrorism or violent extremism',
                id: 'terrorism'
            },
            {
                i18nKey: 'field.subtopic.option.coordinating_to_physically_harm',
                description: 'Coordinating to physically harm',
                id: 'coordinating_to_physically_harm'
            },
            {
                i18nKey: 'field.subtopic.option.threats',
                description: 'Threats or praise of violence',
                id: 'threats'
            },
            {
                i18nKey: 'field.subtopic.option.trafficking',
                description: 'Trafficking',
                id: 'trafficking'
            },
            {
                i18nKey: 'field.subtopic.option.virus',
                description: 'Virus, spyware, or malware',
                id: 'virus'
            },
            {
                i18nKey: 'field.subtopic.option.infringement',
                description: 'Infringement',
                id: 'infringement'
            },
            {
                i18nKey: 'field.subtopic.option.other_report_abuse',
                description: 'Other concern not listed',
                id: 'other_report_abuse'
            },
            {
                i18nKey: 'field.topic.option.community_appeal_moderation',
                description: 'Appeal Content Moderation',
                id: 'community_appeal_moderation'
            },
            {
                i18nKey: 'field.topic.option.community_appeal_account_decision',
                description: 'Appeal account decision',
                id: 'appeal_account_decision'
            },
            {
                i18nKey: 'field.subtopic.option.report_cheater',
                description: 'Report a cheater',
                id: 'report_cheater'
            }
        ]
    },
    platforms: {
        pyramid: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        candycrush: [
            {
                id: 'facebook',
                description: 'Facebook'
            },
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        myling: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        petrescue: [
            {
                id: 'facebook',
                description: 'Facebook'
            },
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        farmking: [
            {
                id: 'facebook',
                description: 'Facebook'
            },
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        bubblewitch2: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        candycrushsoda: [
            {
                id: 'facebook',
                description: 'Facebook'
            },
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        candysolitaire: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        blossomblast: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        candycrushjelly: [
            {
                id: 'facebook',
                description: 'Facebook'
            },
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        farmheroessuper: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        diamonds: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        bubblewitch3: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ],
        gravity: [
            {
                id: 'mobile',
                description: 'Mobile'
            }
        ]
    }
};


// WEBPACK FOOTER //
// ./src/components/Form/selectFieldsConfiguration.js